import { useMutation, useQueryClient, QueryClient } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/checklists/checklist'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { checklistKeys } from '../checklistKeys'
import { IChecklist } from '@core/entities/checklist/Checklist'
import { useMutateQueryData } from '@core/react-query/hooks'
import { checklistsKeys } from '@core/react-query/features/checklists'

export const getCreateChecklistMutationOptions = (queryClient: QueryClient) => {
  const { updateInfiniteQueryItem, deleteInfiniteQueryItem } =
    useMutateQueryData(queryClient)
  return {
    ...checklistKeys.create,
    onSuccess: (checklist, variables) => {
      // 427 idempotent replay: the checklist was created by an earlier attempt
      // and the response carries no body, so refetch the lists instead of patching.
      if (!checklist?.id || !checklist.project?.id) {
        queryClient.invalidateQueries({
          queryKey: checklistsKeys.allChecklists._def,
        })
        if (variables.draftId) {
          queryClient.invalidateQueries({
            queryKey: checklistsKeys.drafts._def,
          })
        }
        return
      }
      queryClient.setQueryData(
        checklistKeys.byId({ checklistId: checklist.id }).queryKey,
        checklist,
      )
      if (variables.draftId) {
        deleteInfiniteQueryItem(
          checklistsKeys.drafts({
            organisationId: checklist.organisationId,
            projectIds: [checklist.project.id],
            isUsedForInspections:
              checklist.template.usedForInspections || undefined,
          }).queryKey,
          variables.draftId,
        )
      }
      updateInfiniteQueryItem(
        checklistsKeys
          .allChecklists({
            organisationId: checklist.organisationId,
            projectIds: [checklist.project.id],
          })
          .queryKey.slice(0, -3),
        checklist,
      )
    },
  }
}

export const useCreateChecklist = () => {
  const queryClient = useQueryClient()

  return useMutation<IChecklist, RequestErrorType, RequestTypes['create']>(
    getCreateChecklistMutationOptions(queryClient),
  )
}
